import { UserDetailDM } from "../data_model/user_detail_dm";
import Axios from "axios";
import ApiUtils from "../utils/api_utils";
import { StarLeaderboardDM } from "../data_model/star_leaderboard_dm";

const ProfileSM = {
  state: {
    profile: new UserDetailDM({}),
    start_leaderboard: new StarLeaderboardDM({}),
  },
  reducers: {
    setProfile(state, payload) {
      return {
        ...state,
        ...payload,
      };
    },
  },
  effects: (dispatch) => ({
    /**
     * get user profile
     */
    async getUserProfile(payload, rootState) {
      await Axios.get(
        `https://${ApiUtils.authority}/profiles/api/users/current/`,
        {
          headers: ApiUtils.getHeader({ token: rootState.LoginSM.token }),
          withCredentials: false,
        }
      )
        .then(function (response) {})
        .catch(function (error) {});
    },

    /**
     * Get User
     */
    async getUsers(payload, rootState) {
      await Axios.get(`https://${ApiUtils.authority}/profiles/api/users/`, {
        headers: ApiUtils.getHeader({ token: rootState.LoginSM.token }),
        withCredentials: false,
      })
        .then(function (response) {})
        .catch(function (error) {});
    },
    /**
     * update user profile
     */
    async updateUserProfile(payload, rootState) {
      return Axios.put(
        `https://${ApiUtils.authority}/profiles/api/users/current/`,
        payload,
        {
          headers: ApiUtils.getHeaderMultipart({
            token: rootState.LoginSM.token,
          }),
          withCredentials: false,
        }
      );
    },

    /**
     * update User
     */
    async updateUser(payload, rootState) {
      const { useId, data } = payload;
      await Axios.put(
        `https://${ApiUtils.authority}/profiles/api/users/${useId}/`,
        data,
        {
          headers: ApiUtils.getHeader({ token: rootState.LoginSM.token }),
          withCredentials: false,
        }
      )
        .then(function (response) {})
        .catch(function (error) {});
    },

    /**
     * Reset / Forgot Password
     * payload => {email}
     */
    async resetPassword(payload, rootState) {
      let result = {};
      await Axios.post(
        `https://${ApiUtils.authority}/profiles/api/users/reset_password/`,
        payload,
        {
          headers: ApiUtils.getHeader({}),
          withCredentials: false,
        }
      )
        .then(function (response) {
          result = {
            status: 200,
            message: ["Reset Password Success"],
          };
        })
        .catch(function (error) {
          result = {
            status: error.response.status,
            message: error.response.data,
          };
        });

      return result;
    },

    /**
     * change password
     * payload => {old_password, new_password}
     */
    async setPassword(payload, rootState) {
      let result = {};
      await Axios.post(
        `https://${ApiUtils.authority}/profiles/api/users/current/set_password/`,
        payload,
        {
          headers: ApiUtils.getHeader({ token: rootState.LoginSM.token }),
          withCredentials: false,
        }
      )
        .then(function (response) {
          result = {
            status: 200,
            message: ["Success"],
          };
        })
        .catch(function (error) {
          result = {
            status: error.response.status,
            message: error.response.data,
          };
        });

      return result;
    },

    /**
     * get Customer Support
     */
    async getCustomerSupport(payload, rootState) {
      await Axios.get(
        `https://${ApiUtils.authority}/profiles/api/customersupport/`,
        {
          headers: ApiUtils.getHeader({ token: rootState.LoginSM.token }),
          withCredentials: false,
        }
      )
        .then(function (response) {})
        .catch(function (error) {});
    },

    /**
     * get stars leaderboard
     */
    async getStarLeaderboard(payload, rootState) {
      let result;
      await Axios.get(
        `https://${ApiUtils.authority}/profiles/api/stars_leaderboard/`,
        {
          headers: ApiUtils.getHeader({ token: rootState.LoginSM.token }),
          withCredentials: false,
        }
      )
        .then(function (response) {
          const data = response.data;
          dispatch.ProfileSM.setProfile({
            start_leaderboard: StarLeaderboardDM.fromJson(data),
          });
          result = {
            status: 200,
            message: ["Success"],
          };
        })
        .catch(function (error) {
          result = {
            status: error.response.status,
            message: error.response.data,
          };
        });

      return result;
    },

    /**
     * get Point leaderboard
     */
    async getPointLeaderboard(payload, rootState) {
      await Axios.get(
        `https://${ApiUtils.authority}/profiles/api/leaderboard/`,
        {
          headers: ApiUtils.getHeader({ token: rootState.LoginSM.token }),
          withCredentials: false,
        }
      )
        .then(function (response) {})
        .catch(function (error) {});
    },
  }),
};

export default ProfileSM;
